import { createContext, useContext } from 'react';

import type { QuestionPickerContextValue } from 'pages/custom_tests_v1/components/question_picker/QuestionPicker';

export const QuestionPickerContext = createContext({} as QuestionPickerContextValue);
QuestionPickerContext.displayName = 'QuestionPickerContext';

export const useQuestionPicker = () => useContext(QuestionPickerContext);